// extracted by mini-css-extract-plugin
module.exports = {"loadingStyle":"antd-pro-components-page-loading-styles-loadingStyle"};